/* eslint-disable camelcase */
import { getTodayNumber } from '../../logic/functions'
import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import { nodeDefaultSizeWithoutSubtitle, nodeDefaultSizeWithSubtitle } from '../../helper/variables'
import { comboTextByOS, handleErrorInCatch } from '../../helper/functions'
import { OneNode } from '../../helper/classes'
import importTreeNodes from './importData'
import * as shortid from 'shortid'
import { defer } from 'lodash'

function returnExampleTreeData () {
  const ratingRecord1 = [
    { rating: 'hard' }
  ]
  const sm2Values1 = {
    failStatus: 'reStudy',
    interval: 10,
    update: getTodayNumber() - 10,
    ratingRecord: ratingRecord1
  }
  const ratingRecord2 = [
    { rating: 'easy' }
  ]
  const sm2Values2 = {
    interval: 3,
    update: getTodayNumber() - 3,
    ratingRecord: ratingRecord2
  }
  const ratingRecord3 = [
    { rating: 'hard' }
  ]
  const sm2Values3 = {
    interval: 1,
    update: getTodayNumber() - 3,
    ratingRecord: ratingRecord3
  }

  const id0 = shortid.generate()
  const node0 = new OneNode(id0, true)
  node0.title = 'This is {{LearnObit}}'
  node0.subtitle = '{{LearnObit}}'
  node0.editableValues = {
    ...node0.editableValues,
    ...sm2Values2
  }

  const id0_1 = shortid.generate()
  const node0_1 = new OneNode(id0_1, true)
  node0_1.title = 'Let it welcome {{you}}'
  node0_1.subtitle = '{{you}}'
  node0_1.editableValues = {
    ...node0_1.editableValues,
    ...sm2Values2
  }

  node0.children = [ node0_1 ]
  node0_1.editableValues.parentId = id0
  node0.editableValues.parentId = 'rootNode'

  const id1 = shortid.generate()
  const node1 = new OneNode(id1, true)
  node1.title = '**This is _example data_ and you can [[remove]] it**'

  const id1_1 = shortid.generate()
  const node1_1 = new OneNode(id1_1, true)
  node1_1.title = 'How to **remove**'
  node1_1.subtitle = 'Right-click on the circular bullet point and choose "Remove"'
  node1_1.expanded = true
  node1_1.editableValues = {
    ...node1_1.editableValues,
    ...sm2Values2
  }
  const node1_1_1 = new OneNode(shortid.generate(), true)
  node1_1_1.title = 'Hotkey'
  node1_1_1.subtitle = `\`${comboTextByOS('mod + shift + backspace')}\` while focusing on the [[node]]`
  node1_1_1.editableValues.parentId = id1_1
  node1_1_1.editableValues = {
    ...node1_1_1.editableValues,
    ...sm2Values3
  }

  node1_1.children = [ node1_1_1 ]
  node1_1.editableValues.orderAsChild = 1
  node1_1.editableValues.parentId = id1
  // node1.children = [ node1_1, node1_2, node1_4 ]

  node1.children = [ node1_1 ]
  node1.editableValues.parentId = 'rootNode'

  // const node1_2 = new OneNode(shortid.generate(), true)
  // node1_2.title = 'See other **example data**'
  // node1_2.subtitle = 'You can see other example data in the Playground'
  // node1_2.editableValues.orderAsChild = 2

  // const node1_3 = new OneNode()
  // node1_3.title = 'Why is there example data here instead of Playground?'
  // node1_3.subtitle = 'Whatever you do in the Playground is not reflected in the Memorizing section, so you cannot try out the Memorizing section. So It\'s needed an example to see how the entries in the Organizing section look like in the Memorizing section, and this is it.'

  const id2 = shortid.generate()
  const node2 = new OneNode(id2, true)
  node2.title = 'Guide'

  const id1_4 = shortid.generate()
  const node1_4 = new OneNode(id1_4, true)
  node1_4.title = '## The 3 most basic things'
  const id1_4_1 = shortid.generate()
  const node1_4_1 = new OneNode(id1_4_1, true)
  node1_4_1.title = 'Node'
  node1_4_1.expanded = false

  const node1_4_1_1_1 = new OneNode(shortid.generate(), true)
  node1_4_1_1_1.title = 'This is the question part of the [[node]]'
  node1_4_1_1_1.subtitle = 'This is the answer part of the [[node]]'
  node1_4_1_1_1.editableValues.parentId = id1_4_1
  node1_4_1_1_1.editableValues = {
    ...node1_4_1_1_1.editableValues,
    ...sm2Values2
  }

  const id1_4_1_1 = shortid.generate()
  const node1_4_1_1 = new OneNode(id1_4_1_1, true)
  node1_4_1_1.title = 'If a [[node]] has no content in the answer part, that\'s the {{context}} node'
  node1_4_1_1.subtitle = '{{context}}'
  node1_4_1_1.editableValues = {
    ...node1_4_1_1.editableValues,
    ...sm2Values3
  }

  // node1_4_1_1.children = [ node1_4_1_1_1 ]
  node1_4_1_1.editableValues.parentId = id1_4_1

  node1_4_1_1_1.editableValues.orderAsChild = 0
  node1_4_1_1.editableValues.orderAsChild = 1

  node1_4_1.children = [ node1_4_1_1_1, node1_4_1_1 ]
  node1_4_1.editableValues.orderAsChild = 0

  const node1_4_2 = new OneNode(shortid.generate(), true)
  node1_4_2.title = 'How to create a new [[node]]'
  node1_4_2.subtitle = '`enter` while focusing on a certain [[node]]'
  node1_4_2.editableValues.orderAsChild = 1
  node1_4_2.editableValues = {
    ...node1_4_2.editableValues,
    ...sm2Values1
  }

  const id1_4_3 = shortid.generate()
  const node1_4_3 = new OneNode(id1_4_3, true)
  node1_4_3.title = 'How to adjust depth'
  node1_4_3.expanded = false
  node1_4_3.editableValues.orderAsChild = 2
  const node1_4_3_1 = new OneNode(shortid.generate(), true)
  node1_4_3_1.title = '+1 depth'
  node1_4_3_1.subtitle = '`tab` while focusing on the [[node]]'
  node1_4_3_1.editableValues.orderAsChild = 0
  node1_4_3_1.editableValues = {
    ...node1_4_3_1.editableValues,
    ...sm2Values2
  }
  const node1_4_3_2 = new OneNode(shortid.generate(), true)
  node1_4_3_2.title = '-1 depth'
  node1_4_3_2.subtitle = '`shift + tab` while focusing on the [[node]]'
  node1_4_3_2.editableValues.orderAsChild = 1
  node1_4_3_1.editableValues.parentId = id1_4_3
  node1_4_3_2.editableValues.parentId = id1_4_3
  node1_4_3_2.editableValues = {
    ...node1_4_3_2.editableValues,
    ...sm2Values2
  }

  node1_4_3.children = [ node1_4_3_1, node1_4_3_2 ]
  node1_4_1.editableValues.parentId = id1_4
  node1_4_2.editableValues.parentId = id1_4
  node1_4_3.editableValues.parentId = id1_4
  node1_4.children = [ node1_4_1, node1_4_2, node1_4_3 ]
  node1_4.editableValues.parentId = id2
  node1_4.editableValues.orderAsChild = 1
  // node1_2.editableValues.parentId = id1

  const id2_2 = shortid.generate()
  const node2_2 = new OneNode(id2_2, true)
  node2_2.title = 'Check the {{Help section}}'
  node2_2.subtitle = '{{Help section}}'
  node2_2.editableValues.parentId = id2
  node2_2.editableValues.orderAsChild = 2

  node2.children = [node1_4, node2_2]
  node2.editableValues.parentId = 'rootNode'

  node0.editableValues.orderAsChild = 0
  node1.editableValues.orderAsChild = 1
  node2.editableValues.orderAsChild = 2

  return [ node0, node1, node2 ]
}

export function setExampleTreeData () {
  globalOnDemandVars.set_globalTreeData(returnExampleTreeData())
}

export async function importCurrentTreeData (treeData) {
  await Promise.all((treeData || globalOnDemandVars.globalTreeData()).map((node, i) => (importTreeNodes(node, { orderAsChild: i, parentId: 'rootNode' }, true))))
}

export const sortF = (a, b) => (
  a.editableValues.orderAsChild - b.editableValues.orderAsChild
)
// console.tron.display({
export let childrenToParents = {}
export const traverse = (node) => {
  //   name: 'one traverse / treenode',
  //   preview: node.id,
  //   value: {
  //     node
  //   }
  //   // , important: true
  // })
  const Id = node.id
  if (Id in childrenToParents) {
    const childrenArrayOfThisNode = childrenToParents[Id]
    childrenArrayOfThisNode.sort(sortF)
    return {
      ...node,
      children: childrenArrayOfThisNode.map(child => traverse(child, childrenToParents))
    }
  } else {
    return { ...node }
  }
}
export async function initTreeNode () {
  globalOnDemandVars.set_treeNodesReady(false)

  const snapshot = await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('TreeNodes').get()
  let treeData
  const isSharing = globalOnDemandVars.isSharing()
  const sharedNodeId = globalOnDemandVars.sharedNodeId()
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'isSharing initTreeNode 0',
      preview: isSharing,
      value: {
        isSharing, sharedNodeId
      }
      // , important: true
    })
  }
  let sharedNode = null
  let canNotShared = false
  if (snapshot.empty) {
    if (isSharing) {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'isSharing initTreeNode 0.1',
          preview: isSharing,
          value: { empty: snapshot.empty }
          // , important: true
        })
      }

      treeData = []
    } else {
      if (globalOnDemandVars.globalTreeData().length) {
        importCurrentTreeData().then(() => {
          globalOnDemandVars.set_treeNodesReady(true)
        })
        return
      } else {
        treeData = returnExampleTreeData()
        importCurrentTreeData(treeData)
      }
    }
  } else {
    if (process.env.NODE_ENV === 'production') {
      window.analytics.identify(globalOnDemandVars.userData().uid, {
        nodes: snapshot.size
      })
    }

    snapshot.forEach((childRef) => {
      const childData = childRef.data()
      const { failStatus, orderAsChild, difficulty, update, interval, ratingRecord, ...others } = childData
      const child = {
        id: childRef.id,
        height: childData.subtitle ? nodeDefaultSizeWithSubtitle : nodeDefaultSizeWithoutSubtitle,
        editableValues: {
          failStatus,
          orderAsChild,
          difficulty,
          update,
          interval,
          ratingRecord
        },
        decorating: {},
        ...others
      }
      const parentId = child.parentId
      if (parentId in childrenToParents) {
        childrenToParents[parentId].push(child)
      } else {
        childrenToParents[parentId] = [child]
      }
      // -----------------------------------------------------------------------------------------------------------
      if (isSharing && child.id === sharedNodeId) {
        sharedNode = child
        globalOnDemandVars.set_sharedNode(sharedNode)

        if (child.parentId === 'removed') {
          globalOnDemandVars.set_canNotSharedBecause('removed')
          canNotShared = true
        }
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'isSharing initTreeNode 0.5',
            preview: sharedNodeId,
            value: {
              sharedNode, sharedNodeId, canNotShared
            }
          // , important: true
          })
        }
      }
      // -----------------------------------------------------------------------------------------------------------
      if (child.decorating.boxHighlight) {
        globalOnDemandVars.boxHighlights()[child.id] = child.decorating.boxHighlight
      }
    })

    if (isSharing && canNotShared) {
      globalOnDemandVars.set_treeNodesReady(true)
      return
    }

    if (!('rootNode' in childrenToParents)) {
      treeData = []
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'isSharing initTreeNode 0.55',
          preview: sharedNodeId,
          value: {
            sharedNode, sharedNodeId, canNotShared, treeData, childrenToParents
          }
          // , important: true
        })
      }
    } else {
      if (isSharing && sharedNodeId !== 'rootNode') {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'isSharing initTreeNode 0.6',
            preview: sharedNodeId,
            value: {
              sharedNode, sharedNodeId, canNotShared
            }
            // , important: true
          })
        }
        const childrenOfSharedNode = childrenToParents[sharedNodeId]
        if (childrenOfSharedNode) {
          childrenOfSharedNode.sort(sortF)
          sharedNode.children = childrenOfSharedNode.map(child => traverse(child))
        } else {
          sharedNode.children = null
        }
        treeData = [ sharedNode ]

        let currentId = sharedNode.parentId
        const keys = Object.keys(childrenToParents)
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'isSharing initTreeNode 0.7',
            preview: sharedNodeId,
            value: {
              sharedNode, sharedNodeId, canNotShared, treeData
            }
            // , important: true
          })
        }

        globalOnDemandVars.sharedNodePath().unshift(sharedNodeId)
        while (true) {
          if (currentId === 'rootNode' || currentId === 'removed') {
            break
          } else {
            globalOnDemandVars.sharedNodePath().unshift(currentId)

            let nextParentNode
            for (let currentParentId of keys) {
              const currentChildren = childrenToParents[currentParentId]
              nextParentNode = currentChildren.find((child) => (child.id === currentId))
              if (nextParentNode) {
                break
              }
            }
            if (!nextParentNode) {
              throw (new Error())
            }
            nextParentNode.children = treeData
            treeData = [ nextParentNode ]
            currentId = nextParentNode.parentId
          }
        }
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'isSharing initTreeNode',
            preview: sharedNodeId,
            value: {
              sharedNode,
              sharedNodeId,
              treeData,
              sharedNodePath: globalOnDemandVars.sharedNodePath()
            }
            // , important: true
          })
        }
      } else {
        const childrenToParent = childrenToParents['rootNode']
        childrenToParent.sort(sortF)
        treeData = childrenToParent.map(child => traverse(child))
      }
    }

    if (!isSharing) {
      let removedNodes = []
      if (childrenToParents['removed']) {
        childrenToParents['removed'].sort((a, b) => {
          if (!b.removedTime) {
            return -1
          } else if (!a.removedTime) {
            return 1
          } else {
            return a.removedTime > b.removedTime ? -1 : 1
          }
        })

        removedNodes = childrenToParents['removed']
      }
      globalOnDemandVars.set_removedNodes(removedNodes)
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'initTreeNode',
      value: {
        treeData
      }
    // , important: true
    })
  }

  globalOnDemandVars.set_globalTreeData(treeData)
  globalOnDemandVars.set_treeNodesReady(true)
}
